var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"input",class:_vm.className,attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"onchange":_vm.onchange,"onkeyup":_vm.onkeyup,"id":_vm.id,"name":_vm.name,"readonly":_vm.readonly},domProps:{"value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }